module.exports = __webpack_public_path__ + "static/media/Inter-Light.5d3776eb.woff";